/* console Promise */
import View from "./View.jsx";

export default [
  {
    path: "/appliance/:selectedDeviceId/consumer-apps-logs",
    controller: context => {
      return {
        component: View,
        context
      };
    }
  }
];
